import { PayloadAction } from "@reduxjs/toolkit";

import { Types } from "../../../../services";
import { TransactionPostingState } from "../../../../utils/types";

export const pending = (state: TransactionPostingState) => {
  state.isLoading = true;
  state.data = null;
};

export const fulfilled = (
  state: TransactionPostingState,
  action: PayloadAction<
    Types.ApiResponse<Types.LoanAdjustmentTypes.TransactionsPostingResponse>
  >
) => {
  state.isLoading = false;
  state.isError = false;
  state.isSuccess = action.payload.success;
  state.data = action.payload.response;
};

export const rejected = (state: TransactionPostingState) => {
  state.isLoading = false;
  state.isError = true;
  state.isSuccess = false;
};
